import React, { useState } from 'react';
import CustomSelect from '../common/CustomSelect';
import UserSelect from '../common/UserSelect';
import { DELIVERY_LABELS, ENV_OPTIONS } from '../../constants/workItem';
import './WorkItemBatchBar.scss';

/**
 * 「我的工作項目」批次操作列。
 * 勾選多個工作項目後浮出;三個動作各自彈面板、各自套用(不必三個都做)。
 * - 改狀態:選狀態 → onStatus(value)
 * - 改 Owner:選人 → onOwner(userId)(原 owner 降協作者,由 setWorkItemOwner 處理)
 * - 加交付紀錄:填一次 → onDelivery(data),每條各寫一筆相同的
 */
const WorkItemBatchBar = ({ count, statusOptions = [], companyUsers = [], onStatus, onOwner, onDelivery, onClear }) => {
  const [panel, setPanel] = useState(null); // status | owner | delivery
  const [busy, setBusy] = useState(false);
  const [dl, setDl] = useState({ label: 'Frontend', version: '', environment: 'staging', note: '' });

  const run = async (fn) => {
    setBusy(true);
    await fn();
    setBusy(false);
    setPanel(null);
    setDl({ label: 'Frontend', version: '', environment: 'staging', note: '' });
  };
  const toggle = (p) => setPanel((cur) => (cur === p ? null : p));

  return (
    <div className="wi-batch">
      {panel === 'status' && (
        <div className="wi-batch-panel">
          <span className="wi-batch-panel-label">改狀態為</span>
          <CustomSelect
            className="wi-batch-select"
            options={(statusOptions || []).map((s) => ({ value: s.value, label: s.label, color: s.color }))}
            onChange={(v) => run(() => onStatus(v))}
            renderOption={(opt) => (
              <span className="wi-batch-status-opt">
                <span className="wi-batch-status-dot" style={{ background: opt.color || '#98a2b3' }} />
                {opt.label}
              </span>
            )}
            placeholder="選擇狀態…"
            searchable
            portal
          />
        </div>
      )}
      {panel === 'owner' && (
        <div className="wi-batch-panel">
          <span className="wi-batch-panel-label">改 Owner 為</span>
          <div className="wi-batch-select">
            <UserSelect
              users={companyUsers}
              values={[]}
              onChange={(ids) => ids[0] && run(() => onOwner(ids[0]))}
              singleSelect
              placeholder="選擇 Owner…"
              portal
            />
          </div>
        </div>
      )}
      {panel === 'delivery' && (
        <div className="wi-batch-panel wi-batch-delivery">
          <CustomSelect className="wi-batch-dl-sel" value={dl.label} onChange={(v) => setDl({ ...dl, label: v })} options={DELIVERY_LABELS.map((l) => ({ value: l, label: l }))} placeholder="標籤" portal />
          <input className="wi-batch-dl-ver" placeholder="版本(如 v1.2.0)" value={dl.version} onChange={(e) => setDl({ ...dl, version: e.target.value })} />
          <CustomSelect className="wi-batch-dl-sel" value={dl.environment} onChange={(v) => setDl({ ...dl, environment: v })} options={ENV_OPTIONS} placeholder="環境" portal />
          <input className="wi-batch-dl-note" placeholder="備註" value={dl.note} onChange={(e) => setDl({ ...dl, note: e.target.value })} />
          <button className="wi-btn-primary" disabled={busy || !dl.label} onClick={() => run(() => onDelivery(dl))}>
            套用到 {count} 項
          </button>
        </div>
      )}

      <div className="wi-batch-bar">
        <span className="wi-batch-count">已選 {count} 項</span>
        <div className="wi-batch-actions">
          <button className={panel === 'status' ? 'active' : ''} disabled={busy} onClick={() => toggle('status')}>改狀態</button>
          <button className={panel === 'owner' ? 'active' : ''} disabled={busy} onClick={() => toggle('owner')}>改 Owner</button>
          <button className={panel === 'delivery' ? 'active' : ''} disabled={busy} onClick={() => toggle('delivery')}>加交付紀錄</button>
        </div>
        <button className="wi-batch-clear" onClick={onClear}>取消選取</button>
      </div>
    </div>
  );
};

export default WorkItemBatchBar;
